import React, { useEffect, useState } from 'react'
import Text from 'antd/es/typography/Text'
import { Select, Space } from 'antd'
import { PATTERN_TYPES } from '../../../../../constants/pattern-types'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import FileCriteriaReasoningTable from './FileCriteriaReasoningTable'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'

const FileCriteriaReasoning = ({ assignment, drawerFileId, fetchFileReasoning }) => {
    const { token, layerId } = useParams()

    const [isWaitingForFileReasoning, setIsWaitingForFileReasoning] = useState(false)
    const [patternIdForGettingReasoning, setPatternIdForGettingReasoning] = useState('None')
    const [criteria, setCriteria] = useState([])

    useEffect(() => {
        setPatternIdForGettingReasoning('None')
        setCriteria([])
    }, [drawerFileId])

    const handlePatternIdForGettingReasoningChange = async id => {
        setPatternIdForGettingReasoning(id)
        setIsWaitingForFileReasoning(true)
        const newCriteria = await fetchFileReasoning(token, layerId, id)
        if (Array.isArray(newCriteria)) {
            setCriteria(newCriteria)
            if (!newCriteria.length) openNotificationWithIcon('warning', 'Reasoning for this file is missing')
        }
        setIsWaitingForFileReasoning(false)
    }

    const fileReasoningSelectorOptions = assignment.patterns
        .filter(pattern => pattern.type === PATTERN_TYPES.SEMANTIC.value)
        .map(pattern => ({
            label: pattern.motif_caption,
            value: pattern.motif_id,
        }))

    const fileReasoningSelector = fileReasoningSelectorOptions.length ? (
        <div className='d-flex-space-between'>
            <label>
                <Text type='secondary' className='mr-4'>
                    Pattern reasoning
                </Text>
                <Select
                    popupMatchSelectWidth={false}
                    value={patternIdForGettingReasoning}
                    loading={isWaitingForFileReasoning}
                    options={fileReasoningSelectorOptions}
                    onChange={handlePatternIdForGettingReasoningChange}
                    getPopupContainer={() => document.getElementById('editor-container')}
                />
            </label>
        </div>
    ) : null

    return (
        <Space direction='vertical'>
            {fileReasoningSelector}
            {!!criteria.length && (
                <FileCriteriaReasoningTable
                    patternId={patternIdForGettingReasoning}
                    criteria={criteria}
                    loading={isWaitingForFileReasoning}
                    token={token}
                    layerId={layerId}
                    fileId={drawerFileId}
                />
            )}
        </Space>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        drawerFileId: assignment.drawer.file.id,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchFileReasoning(token, layerId, patternId) {
            return dispatch(actions.fetchFileReasoning(token, layerId, patternId))
        },
    }
}
export default connect(mapState, mapDispatch)(FileCriteriaReasoning)
